/**
 * Which platforms send reach, and when a stored reach was not sent: a leaf that
 * D1's Result (services/overview) and box 8's coverage (services/looker) both
 * read, so neither imports the other (rules-04 C1, D6). Pure.
 *
 * @module services/platformReach
 */

/**
 * Platforms that send no reach. The same fact as D2's Google reach tile, which reads
 * "ไม่ได้รายงาน" (platformTiles.ts, `fixed('reach', 'notReported')`): Google's writer
 * (GoogleAdsClient) stores reach = 0 on every row, never NULL.
 */
export const PLATFORMS_WITHOUT_REACH: ReadonlySet<string> = new Set(['google']);

/**
 * The platform did not send this reach: it sends none, or the reach is 0 after impressions.
 * A measured reach cannot be 0 once an ad was seen, so that 0 is a platform that sent
 * nothing (LINE). One rule for a fact row and for box 13's campaign alike.
 */
export const reachNotSent = (platform: string, reach: number | null, impressions: number | null): boolean =>
  PLATFORMS_WITHOUT_REACH.has(platform) || (reach === 0 && (impressions ?? 0) > 0);
